const PORTAL_RETURN_FLAG = "heycoach:pendingPortalReturn";

export function stashPendingPortalReturn(returnPath = "/billing") {
  try {
    sessionStorage.setItem(PORTAL_RETURN_FLAG, returnPath);
  } catch {
    // sessionStorage unavailable
  }
}

/** @returns {string|null} return path when returning from Stripe portal */
export function consumePendingPortalReturn() {
  try {
    const path = sessionStorage.getItem(PORTAL_RETURN_FLAG);
    if (!path) return null;
    sessionStorage.removeItem(PORTAL_RETURN_FLAG);
    return path;
  } catch {
    return null;
  }
}
